import {
    Icon20ArticlesOutline,
    Icon20DeleteOutline,
    Icon20LightbulbOutline,
    Icon20LikeOutline,
    Icon20Sync,
    Icon20WriteOutline,
} from '@vkontakte/icons';
import React from 'react';
import { type Messages, ActionCategory, MessageCategory } from 'reactApp/ui/EditorLLM/EditorLLMDialog/types/EditorLlmDialog.types';
import { llmFeature } from 'reactApp/ui/EditorLLM/helpers/EditorLlmHelpers';

export const DEFAULT_MESSAGES: Messages = [
    {
        message: llmFeature.welcomeMessage,
        isOwn: false,
    },
];

export const SCENARIO_SELECT_ICON_MAP = {
    [MessageCategory.TEXT_BY_THEME]: <Icon20WriteOutline />,
    [MessageCategory.BRAINSTORM]: <Icon20LightbulbOutline />,
    [MessageCategory.POST]: <Icon20LikeOutline />,
};

export const ACTIONS_SELECT_ICON_MAP = {
    [ActionCategory.CONTINUE]: <Icon20ArticlesOutline />,
    [ActionCategory.REWRITE]: <Icon20Sync />,
    [ActionCategory.DELETE]: <Icon20DeleteOutline />,
};
